import { CSS_VARIABLES } from "enums/cssVariables";
import styled from "styled-components";

// Title band of the home and login forms: the entity title color on the entity title background.
// A heading for the structure only (RGAA 9.1): it keeps the look of the former div.
export const FormTitle = styled.h1`
    margin: 0;
    font-size: 1.3rem;
    font-weight: inherit;
    padding: 1.25rem 1rem;
    color: var(${CSS_VARIABLES.PRIMARY_TEXT_COLOR});
    background-color: var(${CSS_VARIABLES.BACKGROUND_FORM_COLOR});
`;
